<template>
<div>
  <Home v-if="page == 'home'" />

  <!-- level 1 pages -->
  <Styles v-if="page == 'styles'" />
  <Routes v-if="page == 'routes'" />
  <Countries v-if="page == 'countries'" />
  <RidertagsAndSites v-if="page == 'ridertags'" :type="'ridertags'"/>
  <RidertagsAndSites v-if="page == 'sites'" :type="'sites'"/>
  <Books v-if="page == 'books'" />
  <AddTrip v-if="page == 'share'" />
  <HowItWorks v-if="page == 'about'" />
  
  
  <!-- level 2 pages -->
  <Route v-if="page == 'route'" :route="this.$route.query.routes"/>
  <Country v-if="page == 'country'" :country="this.$route.query.countries"/>
  <Style v-if="page == 'style'" :style_name="this.$route.query.style" />
  <PageResultsList v-if="page == 'ridertags'" :ridertag="this.$route.query.ridertags"/>
  <PageResultsList v-if="page == 'sites'" :site="this.$route.query.sites"/>
  <Continent v-if="page == 'continent'" :continent="this.$route.query.continents" />

  <!-- level 3 pages -->
  <State v-if="page == 'subregion'" :state="this.$route.query.subregion" />

  <!-- <FeatureDesert v-if="pagename == 'desert'" /> -->
</div>
</template>

<script>
import Home from '@/components/Home';
import Styles from '@/components/Styles';
import Routes from '@/components/Routes';
import Countries from '@/components/Countries';
import RidertagsAndSites from '@/components/RidertagsAndSites';
import Books from '@/components/Books';
import AddTrip from '@/components/AddTrip';
import HowItWorks from '@/components/HowItWorks';

import Route from '@/components/Route';
import Country from '@/components/Country';
import Style from '@/components/Style';
import PageResultsList from '@/components/PageResultsList';
import Continent from '@/components/Continent';
import State from '@/components/State';
import Router from 'vue-router'
const { isNavigationFailure, NavigationFailureType } = Router;
export default {
  name: 'IndexLevel1',
  components: { Styles, Routes, Countries, RidertagsAndSites, Books, AddTrip, HowItWorks, Home, Route, Country, Style, PageResultsList, Continent, State }, //Also need subregions
  // props: ['list'],
  data () {
    return {
      page: '',
      level2: ''
    }
  },
  methods: {
   
  },
  beforeMount() {
    if (this.$route.query.page) {
      this.page = this.$route.query.page;
      // console.log("pagename is " + this.page);
      if (this.page == 'home') {
        // window.history.replaceState({}, '', '/');
        this.$router.replace( {path: '/'});
      } else {
        // window.history.replaceState({}, '', '/' + this.page);
        this.$router.replace( {path: this.page});
      }
    } else if (this.$route.query.routes) {
      this.page = 'route';
      this.$router.replace( {path: '/routes/' + this.$route.query.routes});
    } else if (this.$route.query.subregion && this.$route.query.countries) {
      this.page = 'subregion';
      this.$router.replace( {path: '/countries/' + this.$route.query.countries + '/' + this.$route.query.subregion});
    } else if (this.$route.query.countries) {
      this.page = 'country';
      this.$router.replace( {path: '/countries/' + this.$route.query.countries});
    } else if (this.$route.query.style) {
      this.page = 'style';
      // this.level2 = this.$route.query.style;
      this.$router.replace( {path: '/style/' + this.$route.query.style});
    } else if (this.$route.query.ridertags) {
      this.page = 'ridertags';
      this.$router.replace( {path: '/ridertags/' + this.$route.query.ridertags});
    } else if (this.$route.query.sites) {
      this.page = 'sites';
      this.$router.replace( {path: '/sites/' + this.$route.query.sites});
    } else if (this.$route.query.continents) {
      this.page = 'continent';
      this.$router.replace( {path: '/continents/' + this.$route.query.continents});
    } else {
      this.page = "home";
      // window.history.replaceState({}, '', '/');
      this.$router.replace( {path: '/'}).catch(failure => {
        if (isNavigationFailure(failure, NavigationFailureType.duplicated)) {
          // show a small notification to the user
        }
      });
    }
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  
</style>


// WEBPACK FOOTER //
// src/components/IndexLevel1.vue